import { render, staticRenderFns } from "./mother-profile.vue?vue&type=template&id=7fdf7b3c&scoped=true"
import script from "./mother-profile.vue?vue&type=script&lang=js"
export * from "./mother-profile.vue?vue&type=script&lang=js"
import style0 from "./mother-profile.vue?vue&type=style&index=0&id=7fdf7b3c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdf7b3c",
  null
  
)

export default component.exports